import * as React from "react";
import { IdLang } from "../../utils/i18n/IdLang";
export var ContextLoca = React.createContext(IdLang.None);



//////////////////
// WEBPACK FOOTER
// ./src/features/loca/ContextLoca.ts
// module id = 474
// module chunks = 3